import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {compose} from 'recompose';
import {Manager, Target, Popper} from 'react-popper';
import WithClickOutside from '../../hoc/WithClickOutside';
import silverCoinImage from '../../../assets/yakcoin_silver.png';
import goldCoinImage from '../../../assets/yakcoin_gold.png';
import {Button} from '../index';

class Coins extends PureComponent {
  static propTypes = {
    ableToSendGiftsForFree: PropTypes.bool.isRequired,
    onCoinPacksModalOpen: PropTypes.func.isRequired,
    coins: PropTypes.shape({
      gold: PropTypes.number.isRequired,
      silver: PropTypes.number.isRequired,
    }).isRequired,
    clickOutside: PropTypes.bool.isRequired,
  };

  render() {
    const {
      ableToSendGiftsForFree,
      clickOutside,
      coins: {gold, silver},
      onCoinPacksModalOpen,
    } = this.props;

    if (clickOutside) {
      return false;
    }

    return (
      <Manager>
        <Target/>
        <Popper className="popper coins-popper" placement="bottom-end">
          <div id="paypal-button-container">
            {!ableToSendGiftsForFree && (
              <div className="flex mb-2">
                <span>YakSilver</span>
                <img className="coins-popper__icon" src={silverCoinImage} height="20" alt=""/>
                <span>{silver}</span>
              </div>
            )}

            <div className="flex mb-2">
              <span>YakGold</span>
              <img className="coins-popper__icon" src={goldCoinImage} height="20" alt=""/>
              <span>{gold}</span>
            </div>

            {!ableToSendGiftsForFree && (
              <Button
                className="mt-1"
                text="Buy More YakSilver"
                handler={onCoinPacksModalOpen}
              />
            )}
          </div>
        </Popper>
      </Manager>
    );
  }
}

export default compose(
  WithClickOutside,
)(Coins);
